import { AvailableVehicles } from "./AvailableVehicles";

export class ReusableVehicles extends AvailableVehicles{
    
}